import { render } from "./PanelAvisosHomeTabla.vue?vue&type=template&id=508867e2"
import script from "./PanelAvisosHomeTabla.vue?vue&type=script&lang=js"
export * from "./PanelAvisosHomeTabla.vue?vue&type=script&lang=js"

import "./PanelAvisosHomeTabla.vue?vue&type=style&index=0&id=508867e2&lang=css"
script.render = render

export default script